import { render, staticRenderFns } from "./PurOrderBillList.vue?vue&type=template&id=d12fc126&scoped=true&"
import script from "./PurOrderBillList.vue?vue&type=script&lang=js&"
export * from "./PurOrderBillList.vue?vue&type=script&lang=js&"
import style0 from "./PurOrderBillList.vue?vue&type=style&index=0&id=d12fc126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12fc126",
  null
  
)

export default component.exports